export default {
  placeholder: {
    reason_reject: 'Enter the reason of reject',
    reason_route: 'Enter the reason for deviation of the route',
    reason_delete: 'Enter the reason of reject',
  },
  route: {
    label: {
      name: 'Route name',
      number: 'Route number',
      total_distance: 'Total distance (km)',
      time_planned: 'Time planned (hr)',
    },
    placeholder: {
      name: 'Enter route name',
      number: 'Enter route number',
      total_distance: 'Enter total distance',
      time_planned: 'Enter time planned',
    },
  },
  employee: {
    label: {
      employee: 'Employee',
    },
    placeholder: {
      employee: 'Enter employee',
      employee_single: 'Enter employee',
    },
    all: 'All',
    active: 'All (active)'
  },
  filter_journeys_placeholder: 'All journeys statuses',
  optional: 'optional',
}
